import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ExceptionState } from 'src/shared/components/exceptionState';
import { Image } from 'src/shared/components/image';
import RootErrorImage from 'public/assets/images/rootError.svg';
export const RootError = () => {
    const { t } = useTranslation();
    return (_jsxs(ExceptionState, { className: "mx-6 py-15", children: [_jsx(Image, { src: RootErrorImage, "aria-hidden": true }), _jsx(ExceptionState.Title, { children: t('error_boundary.title') }), _jsx(ExceptionState.Description, { classNames: "max-w-[332px]", children: t('error_boundary.subtitle') })] }));
};
